<template>
    <div>
        <app-sub-title text="Vehículos" />

        <b-row v-if="!isVigilance">
            <b-col cols="12" md="6" v-if="canSelectClient">
                <app-autocomplete
                    placeholder="Clientes"
                    :items="clients"
                    v-model="selectClient"
                    @change="startLoadVehicles"
                />
            </b-col>
            <b-col cols="12" md="6" lg="3">
                <button :disabled="!selectClient" class="btn btn-primary" @click="startSaveVehicle()">
                    <i class="fa fa-car"></i> Crear nuevo vehículo
                </button>
            </b-col>
        </b-row>

        <b-row v-if="isVigilance">
            <b-col cols="12" sm="6" md="4">
                <button :disabled="!selectClient" class="btn btn-primary" @click="startSaveVehicle()">
                    <i class="fa fa-car"></i> Crear nuevo vehículo
                </button>
            </b-col>
        </b-row>

        <div class="filters" v-if="!!this.selectClient">
            <app-sub-title text="Filtros" />
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <b-row>
                            <b-col cols="12" md="auto">
                                <app-form-text-input
                                    placeholder="Estructura"
                                    v-model="filters.structure"
                                />
                            </b-col>
                            <b-col cols="12" md="auto">
                                <app-form-text-input
                                    placeholder="placa"
                                    v-model="filters.plate"
                                    :input-classes="{ 'plate-input': true }"
                                />
                            </b-col>
                            <b-col cols="12" md="auto">
                                <app-form-select-input
                                    placeholder="Tipo vehículo"
                                    :options="vehicleTypes"
                                    v-model="filters.type"
                                />
                            </b-col>
                            <b-col cols="12" md="auto">
                                <app-form-select-input
                                    placeholder="Interno"
                                    :options="optionsInternal"
                                    v-model="filters.internal"
                                />
                            </b-col>
                            <b-col cols="12" md="auto">
                                <app-form-text-input
                                    placeholder="Marca"
                                    v-model="filters.brand"
                                />
                            </b-col>
                            <b-col cols="12" md="auto">
                                <app-form-text-input
                                    placeholder="Propietario"
                                    v-model="filters.owner"
                                />
                            </b-col>
                            <b-col cols="12" md="auto">
                                <app-form-text-input
                                    placeholder="Notas"
                                    v-model="filters.notes"
                                />
                            </b-col>
                            <b-col class="d-flex justify-content-end align-items-center">
                                <b-btn variant="primary" @click="searchVehicles" class="">
                                    <i class="fa fa-filter"></i>
                                </b-btn>
                                <b-btn @click="cancelFilter" class="ml-2">
                                    <i class="fa fa-times-circle"></i>
                                </b-btn>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
        <app-table-vehicles v-if="!!this.selectClient"
            :data="data"
            :on-change-page="onChangePage"
            :see-card="seeCard"
            :start-remove="startRemove"
            :start-update="startUpdate"
            :start-save-photos="startSavePhotos"
            @sort="onSort"
        />

        <!-- inicio de pop ups -->

        <app-pop-up title="Confirmación" id="vehicle-remove">
            <div slot="body">
                <h2>¿Esta seguro que desea eliminar este vehículo?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button class="btn btn-confirm" @click="deleteVehicle(selectVehicle)">
                    <i class="fa fa-trash-o" aria-hidden="true"></i> Confirmar Eliminación
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Formulario de vehículo" id="vehicle-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-vehicle-form-page v-if="!!selectClient" :my-vehicle="selectVehicle" :my-client="selectClient" :onSave="onSave" @close="onVehicleFormClose"></app-vehicle-form-page>
            </div>
            <div slot="buttons">
                <button class="btn btn-confirm" :disabled="inProgress" @click="$bus.$emit('vehicle-form.save')"> Guardar</button>
            </div>
        </app-pop-up>
        <app-pop-up title="Subir fotos del vehículo" id="vehicle-photos-popup" :onClose="cleanFormPhotos">
                <div class="body" slot="body">
                   <app-upload-or-take-photo id="vehicle-photos" title="Fotos de vehículo" v-model="files" />
                </div>
                <div class="buttons" slot="buttons">
                <button :disabled="isDisable" class="btn btn-confirm" @click="uploadPhotos(selectVehicle)">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> Guardar Fotos
                </button>
            </div>
        </app-pop-up>
        <app-pop-up title="Fotos del vehículo" id="view-vehicle-photos" :onClose="cleanCardVehicle" size="large">
            <div class="body" slot="body">
                <app-vehicle-card v-if="selectVehicle" :client-id="selectClient.id" :vehicle="selectVehicle"></app-vehicle-card>
            </div>
            <div class="buttons" slot="buttons">

            </div>
        </app-pop-up>

        <!-- fin de pop ups -->
    </div>
</template>
<script>
    import vehiclesRepository from '../../../repositories/vehicles.repository.js';
    import VehicleFormPage from '../Vehicles/VehicleFormPage.vue';
    import { required } from 'vuelidate/lib/validators';
    import UploadOrTakePhoto from '../../UI/Controls/Photos/UploadOrTakePhoto.vue';
    import VehicleCard from '../../Clients/VehicleCard/VehicleCard.vue';
    import TableVehicles from './TableVehicles/TableVehicles.vue';
    import { mapGetters } from 'vuex';
    // import Autocomplete from '../../UI/Controls/AutocompleteV2/Autocomplete.vue';

    export default {
        components: {
            appVehicleFormPage: VehicleFormPage,
            appUploadOrTakePhoto: UploadOrTakePhoto,
            appVehicleCard: VehicleCard,
            appTableVehicles: TableVehicles,
            // appAutocomplete: Autocomplete

        },
        data() {
            return {
                page: 1,
                selectVehicle: '',
                selectClient: '',
                filters: {
                    structure: '',
                    plate: '',
                    internal: '',
                    type: '',
                    brand: '',
                    reference: '',
                    notes: '',
                    owner: '',
                },
                // vehicleTypes: [],
                optionsInternal: [
                    {id: 1, name: 'SI'},
                    {id: 0, name: 'NO'}
                ],
                files: {
                    files: [],
                    photos: []
                },
                isDisable: true,
                isVigilance: false,
                isClient: false,
                data: {},
                sort: {
                    sortBy: 'plate',
                    sortDir: 'asc'
                }
            };
        },

        validations: {
            selectClient: { required }
        },

        watch: {
            files(val){
                if(val){
                    if(this.files.files.length!=0){
                        this.isDisable = false;
                    }
                    else if(this.files.photos.length!=0){
                        this.isDisable = false;
                    }
                    else{
                    this.isDisable = true;
                    }
                }
            }
        },
        computed: {
            ...mapGetters(['clients', 'vehicleTypes']),
            canSelectClient() {
                if(this.user.profile.client_side)
                    return false;

                if(this.user.profile.client_required)
                    return false;

                return true;
            }
        },
        methods: {
            onSave() {
                this.$bus.$emit('vehicle-form.close');
                this.loadVehicles(this.selectClient.id);
            },
            cleanCardVehicle(){
                this.$bus.$emit('view-photos-vehicle.clean');
                this.$bus.$emit('vehicle-entry-history.clean');

            },
            cleanForm() {
                this.$bus.$emit('vehicle-form.clean');
            },
            cleanFormPhotos(){
                this.files = '';
                this.$bus.$emit('vehicle-photos.clean')
                this.startLoadVehicles();
            },
            loadVehicles(clientId) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return false;
                }
                const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir };

                const vr = Object.assign({}, vehiclesRepository);
                vr
                    .searchVehiclesOfClient(clientId, filters, this.page )
                    .then(data => {
                        this.data = data;
                    })
                    .catch(error =>
                        toastr.error('Ocurrio un error al cargar los vehículos')
                    );
            },
            // loadVehicleTypes(){
            //     const vr = Object.assign({}, vehiclesRepository);
            //     vr
            //         .getTypes()
            //         .then(data => this.vehicleTypes = data)
            //         .catch(error => toastr.error('Error al cargar los tipos de vehículo'))
            // },
            deleteVehicle(vehicle) {
                const pr = Object.assign({}, vehiclesRepository);
                pr
                    .deleteVehicle(vehicle.id, this.user.id)
                    .then(data => {
                        if (data.status) {
                            toastr.success(data.msg);
                            this.loadVehicles(this.selectClient.id);
                            this.$bus.$emit('vehicle-remove.close');
                        } else {
                            toastr.error(data.msg);
                        }
                    })
                    .catch(error => {
                        toastr.error('No se pudo borrar el vehículo');
                    });
            },
            uploadPhotos(vehicle){
                if(!this.files){
                    toastr.error('No hay archivos o fotos que guardar');
                    return;
                }
                const formData = new FormData();

                this.files.files.map((item, index) => formData.append('file' + index, item));
                this.files.photos.map(item => formData.append('photos[]', item));
                formData.append('vehicleId', vehicle.id);

                const vc = Object.assign({}, vehiclesRepository);
                vc
                    .savePhotos(formData)
                    .then(data => {
                        if(data.status){
                            this.$bus.$emit('vehicle-photos-popup.close');
                            toastr.success(data.msg);
                        }else{
                            toastr.error(data.msg);
                        }
                    })
                    .catch(error => {
                        toastr.error('No fue posible guardar las fotos del vehículo')
                    });

            },
            startRemove(vehicle) {
                this.selectVehicle = vehicle;
                this.$bus.$emit('vehicle-remove.open');
            },
            startUpdate(vehicle) {
                this.selectVehicle = Object.assign({}, vehicle);
                this.$bus.$emit('vehicle-form.open');
            },
            startSavePhotos(vehicle){
                this.selectVehicle = Object.assign({}, vehicle);
                this.$bus.$emit('vehicle-photos-popup.open');
            },
            startSaveVehicle() {
                this.selectVehicle = '';
                this.$bus.$emit('vehicle-form.open');
            },
            startLoadVehicles() {
                if(!this.selectClient) return;
                this.$v.selectClient.$touch();
                this.loadVehicles(this.selectClient.id);
            },
            seeCard(vehicle){
                this.selectVehicle = vehicle;
                this.$bus.$emit('view-vehicle-photos.open');
            },
            searchVehicles(){
                this.page = 1;
                this.loadVehicles(this.selectClient.id);
            },
            cancelFilter() {
                this.page = 1;
                Object.keys(this.filters).map(key => this.filters[key] = '');
                this.loadVehicles(this.selectClient.id);
            },
            onChangePage(page){
                this.page = page;
                this.loadVehicles(this.selectClient.id);
            },
            onSort(ctx) {
                this.sort.sortBy = ctx.sortBy;
                this.sort.sortDir = ctx.sortDir;
                this.loadVehicles(this.selectClient.id);
            },
            onVehicleFormClose() {
                this.$bus.$emit('vehicle-form.close');
            }
        },

        created() {
            // this.loadVehicleTypes();
            this.load('vehicleTypes');
            this.load('clients');
            this.isVigilance = this.user.profile.slug === 'vigilante' ? true: false;
            this.isClient = this.user.profile.slug === 'cliente-admin' ? true: false;
            if(this.isVigilance){
                this.selectClient = this.client;
                this.startLoadVehicles();
            }
            if(this.isClient){
                 this.selectClient = this.client;
                 this.startLoadVehicles();
            }
        }
    };
</script>
